<template>
  <div>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else>
      <v-row>
        <v-col cols="12" v-if="outstanding.length == 0">
          <v-card>
            <v-card-title>
              All Culture Tracking surveys have been completed
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" v-for="(item, i) in outstanding" :key="i">
          <v-card>
            <v-row>
              <v-col cols="auto" class="my-auto">
                <v-card-text>
                  <v-btn
                    :href="item.link"
                    target="_blank"
                    color="performance"
                    v-if="item.completeDate == null"
                    @click="setCompleteDate(item)"
                  >
                    Start Culture Tracking
                  </v-btn>
                  <v-btn disabled v-else>
                    Started
                  </v-btn>
                </v-card-text>
              </v-col>
              <v-col cols="auto">
                <v-card-title>
                  Culture Tracking
                </v-card-title>
                <v-card-subtitle>
                  Sent: {{ item.createdDate | normalDate }}
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "PulseQueue",
  props: {},
  components: {},
  data: () => ({ loading: false }),
  computed: {
    ...mapGetters({
      outstanding: "pulse/outstanding",
      profile: "profile/profile"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("pulse/getOutstandingPulses")
      .then(() => {
        if (this.outstanding.length == 1) {
          this.setCompleteDate(this.outstanding[0]);
          window.open(this.outstanding[0].link, "_blank");
        }
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your culture tracking surveys."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    setCompleteDate(item) {
      this.$set(item, "completeDate", moment());
    }
  }
};
</script>
